import { Component, Inject} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-offline-toast',
    templateUrl: './offline-toast.component.html',
    imports: [TranslateModule, MatButtonModule],
    styleUrls: ['./offline-toast.component.scss']
})
export class OfflineToastComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private MatDialogRef: MatDialogRef<OfflineToastComponent>){}

    closeDialog (){
        this.MatDialogRef.close();
    }
}
